import Card from '@/components/Card';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { DoorOpen, FileSlidersIcon } from 'lucide-react';
import { type Dispatch, type SetStateAction } from 'react';
import { FileAvatar } from './styles';
import { stringToColor } from '@/utils/stringUtils';
import { Button } from '@/components/Button';
import Carousel from '@/components/Carousel';
import { useTranslation } from 'react-i18next';

function FileList({
  files,
  selectedModelKey,
  setSelectedFile,
  setDialogFile,
}: {
  files: FileType[];
  selectedModelKey: string;
  setSelectedFile: Dispatch<SetStateAction<FileType | null>>;
  setDialogFile: Dispatch<SetStateAction<boolean>>;
  setConfirmDelete: Dispatch<SetStateAction<boolean>>;
}) {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    files.length > 0 &&
    files !== null && (
      <Stack alignItems="flex-start" width="100%" gap="24px">
        <Stack direction="row" textAlign="left" gap="24px" alignItems="center">
          <Typography variant="h3" textAlign="left">
            {t('config.files.files')}
          </Typography>
          <Typography
            variant="h5"
            color={theme.palette.primary.main}
          >{` ${selectedModelKey}`}</Typography>
        </Stack>

        <Stack direction="row" spacing={6} maxWidth="100%" width="100%">
          <Carousel>
            {files.map((file: FileType) => {
              const bgColor = stringToColor(
                file?.completeName || Math.random().toString()
              );

              return (
                <Card
                  sx={{
                    minWidth: '320px',
                    width: '320px',
                    height: '100%',
                    padding: '0',
                  }}
                >
                  <Stack
                    direction="column"
                    gap="4px"
                    alignItems="center"
                    width="100%"
                  >
                    <FileAvatar $bgColor={bgColor}>
                      <FileSlidersIcon
                        color={theme.palette.fixed.white}
                        strokeWidth={1}
                        size={72}
                      />
                    </FileAvatar>
                    <Stack
                      direction="row"
                      gap="4px"
                      alignItems="center"
                      sx={{
                        padding: '12px 12px',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        overflowWrap: 'break-word',
                      }}
                    >
                      <Typography
                        variant="h4"
                        textAlign="left"
                        whiteSpace="wrap"
                        width="270px"
                      >
                        {file?.completeName}
                      </Typography>
                    </Stack>

                    <Stack
                      direction="row"
                      justifyContent="flex-end"
                      mb="24px"
                      mr="24px"
                      width="100%"
                    >
                      <Button
                        height="36px"
                        onClick={() => {
                          setSelectedFile(file);
                          setDialogFile(true);
                        }}
                        startIcon={<DoorOpen />}
                        variant="secondary"
                      >
                        {t('config.files.actions')}
                      </Button>
                    </Stack>
                  </Stack>
                </Card>
              );
            })}
          </Carousel>
        </Stack>
      </Stack>
    )
  );
}

export default FileList;
